import { fg } from '@atlaskit/platform-feature-flags/fg';

import { ProductKeys } from '../product-keys';

// TODO QS-4805: We're slowly moving all filter typing to use this as a reference so we can be strongly typed!
// If you find a filterId masquerading as a `string` please consider migrating it
export type FilterId =
	| 'archived'
	| 'assignee'
	| 'reporter'
	| 'commentedByMe'
	| 'content'
	| 'contributor'
	| 'createdBy'
	| 'lastUpdated'
	| 'project'
	| 'space'
	| 'site'
	| 'verified'
	| 'onlyTitleMatch'
	| 'universalTypeFilter'
	| 'focusAreaType'
	| 'focusAreaUnder'
	| 'owner'
	| 'label'
	| 'tag'
	| 'pageStatus'
	| 'lastUpdatedBy'
	| 'statusFilter'
	| 'compassArchived'
	| 'assetsSchema'
	| 'assetsType'
	| 'watchedByMe'
	| 'positionStatus'
	| 'positionEmploymentType'
	| 'positionJobFamily'
	| 'positionTeam'
	| 'positionFocusArea'
	| 'sort'
	| 'salesforceStage'
	| 'repository'
	| 'reviewer'
	| 'closeDate'
	| 'opportunityStatus'
	| 'campaignStatus'
	| 'caseStatus'
	| 'documentStatus'
	| 'calendarType'
	| 'leadStatus'
	| 'taskStatus'
	| 'taskType'
	| 'pullRequestStatus'
	| 'slackChannel'
	| 'folder'
	| 'workspaceName'
	| 'hasAttachment';
// Keeping these separate for now

export const universalTypeFilterId = 'universalTypeFilter';
export const filterIdOrdering: string[] = [
	'lastUpdated',
	universalTypeFilterId,
	'contributor',
	'space',
	'createdBy',
	'lastUpdatedBy',
	'owner',
	'opportunityStatus',
	'campaignStatus',
	'caseStatus',
	'documentStatus',
	'calendarType',
	'leadStatus',
	'taskStatus',
	'taskType',
	'closeDate',
	'focusAreaType',
	'focusAreaUnder',
	'assignee',
	'reporter',
	'project',
	'content',
	'label',
	'tag',
	'folder',
	'pageStatus',
	'verified',
	'onlyTitleMatch',
	'archived',
	'statusFilter',
	'compassArchived',
	'assetsSchema',
	'assetsType',
	'watchedByMe',
	'positionFocusArea',
	'positionStatus',
	'positionJobFamily',
	'positionTeam',
	'commentedByMe',
	'positionEmploymentType',
	'salesforceStage',
	'repository',
	'reviewer',
	'pullRequestStatus',
	'slackChannel',
	'workspaceName',
	'hasAttachment',
];

export const getFilterIdOrdering: () => string[] = (): string[] => {
	return filterIdOrdering.filter((filterId) => {
		if ((filterId === 'tag' || filterId === 'folder') && !fg('loom-rovo-search')) {
			return false;
		}
		if (filterId === 'workspaceName' && !fg('rovo_fps_show_workspace_name_filter')) {
			return false;
		}
		return true;
	});
};

export const SEARCH_PAGE_FILTER_CONFIG_KEY_V2 = 'search-page-hidden-filters-v2';

export const getSearchPageFilterConfigKey: () => string = (): string => {
	return SEARCH_PAGE_FILTER_CONFIG_KEY_V2;
};

export const ALL_FILTER_EXCLUDED_PRODUCTS: ('outlook-mail' | 'gmail' | 'trello')[] = [
	ProductKeys.Trello,
	ProductKeys.Gmail,
	ProductKeys.OutlookMail,
];
